import React from 'react'
import Heading from '../common/ui/Heading';
import mindsetImg from '../../assets/images/webp/mindset-nation-img.webp';
import deepakSharmaUserImg from '../../assets/images/png/deepak-sharma-circle-img.png'
import { PUBLISH_ARTICLES_LIST } from '../../utils/other-component';
const PublishArticles = () => {
  return (
    <>
      <div className="py-[140px] px-4 max-xl:py-[120px] max-lg:py-24 max-md:py-20 max-sm:py-10">
        <div className="max-w-[1140px] mx-auto">
          <Heading children="Published Articles by Deepak Ji" />
          <div className="border border-solid border-[#0101011A] mt-[50px] max-lg:mt-10 max-md:mt-6 rounded-2xl shadow-[0px_4px_17.7px_0px_#0000001A] p-[1px] transition-all ease-linear duration-300 hover:bg-[linear-gradient(270.39deg,rgba(152,198,78,0.7)_2.61%,rgba(63,138,49,0.7)_96.31%)]">
            <div className="w-full bg-[#FEFEFE] flex items-center max-xl:gap-5 max-lg:flex-wrap justify-between p-10 max-xl:p-6  rounded-2xl">
              <img
                src={mindsetImg}
                alt="mind-set"
                className="w-full max-w-[591px] pointer-events-none max-lg:max-w-full"
              />
              <div className="max-w-[398px] max-lg:max-w-full">
                <h2 className="text-[#001A3D] text-[32px] pb-[14px] max-md:text-2xl font-bold leading-[120%]">
                  Youth Mindset, Nation’s Future
                </h2>
                <p className="font-bold text-base leading-[150%] text-[#4C4C4C] uppercase">
                  Published in:
                  <span className="text-[#2920D2]"> Dainik Bhaskar </span>
                </p>
                <p className="font-normal text-base leading-[150%] pt-[10px]">
                  <span className="text-[#010101] font-bold">Summary:</span> In
                  this article, Deepak Ji explains how a change in mindset can
                  redirect the course of one's entire life.
                </p>
                <div className="flex items-center gap-3 pt-[10px]">
                  <img
                    src={deepakSharmaUserImg}
                    alt="deepak"
                    className="w-full max-w-[43px]"
                  />
                  <div className="flex flex-col">
                    <h3 className="text-[#001A3D] font-semibold text-sm leading-[19.31px]">
                      Deepak Sharma
                    </h3>
                    <p className="text-[#001A3D] font-normal text-xs leading-[160%]">
                      Apr 20 , 2 min read
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-wrap items-center max-lg:items-start gap-6 mt-10">
            {PUBLISH_ARTICLES_LIST.map((obj, i) => (
              <div
                key={i}
                className="border border-solid w-full max-w-[558px] max-md:max-w-full max-md:mx-auto max-xl:max-w-[480px] border-[#0101011A] max-lg:max-w-[355px] rounded-2xl shadow-[0px_4px_17.7px_0px_#0000001A] p-[1px] transition-all ease-linear duration-300 hover:bg-[linear-gradient(270.39deg,rgba(152,198,78,0.7)_2.61%,rgba(63,138,49,0.7)_96.31%)]"
              >
                <div className="w-full bg-[#FEFEFE] rounded-2xl p-4">
                  <img
                    src={obj.img}
                    alt="visons"
                    className="w-full max-w-[526px] pointer-events-none max-md:max-w-full"
                  />
                  <h2 className="text-[#001A3D] text-2xl max-sm:text-xl font-bold leading-[120%] pt-4">
                    {obj.title}
                  </h2>
                  <p className="font-bold text-base leading-[150%] text-[#4C4C4C] uppercase pt-[14px]">
                    Published in:
                    <span className="text-[#2920D2]">{obj.paperName}</span>
                  </p>
                  <p className="font-normal text-base leading-[150%] pt-[10px]">
                    <span className="text-[#010101] font-bold">Summary:</span>
                    {obj.description}
                  </p>
                  <div className="flex items-center gap-3 pt-[10px]">
                    <img
                      src={deepakSharmaUserImg}
                      alt="deepak"
                      className="w-full max-w-[43px]"
                    />
                    <div className="flex flex-col">
                      <h3 className="text-[#001A3D] font-semibold text-sm leading-[19.31px]">
                        Deepak Sharma
                      </h3>
                      <p className="text-[#001A3D] font-normal text-xs leading-[160%]">
                        Apr 20 , 2 min read
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default PublishArticles